export default __webpack_public_path__ + "static/media/product-22.690d4f1e.jpg";